module.exports = __webpack_public_path__ + "img/JoernMeyer_140x140_rund.585c0944.jpg";